<template>
  <div class="pagination-wrap">
    <el-pagination
      background
      :layout="layout"
      :total="total"
      :page-size="pageSize"
      :pager-count="pagerCount"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <span
      v-if="lan == 'ch'"
      class="tiaozhuan"
      @click="handleSizeChange"
    >确定</span>
<!--    <span-->
<!--      v-else-->
<!--      class="tiaozhuan"-->
<!--      @click="handleSizeChange"-->
<!--    >GO</span>-->
  </div>
</template>

<script>
import { scrollTo } from "../../common/scrollTo";
import Cook from "../../common/cookie";
import { language } from "../../language/get";

export default {
  props: {
    layout: {
      type: String,
      default: "prev, pager, next, jumper",
    },
    limit: {
      type: Number,
      default: 10,
    },
    total: {
      required: true,
      type: Number,
    },
    pagerCount: {
      type: Number,
      default: 5,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      },
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    forumTabsHeight: {
      type: Number,
      default: 0,
    },
    jumpColor:{
      type: String
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  data() {
    return {
      lan: Cook.get("lang"),
      jumperColor:"white"
    };
  },
  mounted() {
    if(this.jumpColor){
      this.jumperColor = this.jumpColor;
    }else{
      this.jumperColor = 'white';
    }
    let me=this
    function setEn(){
      let elements=document.getElementsByClassName('el-pagination__jump')||[]

      for(let item of elements){
        console.log(me.jumperColor)
        item.style.color=me.jumperColor
        if (me.lan=='en') {
          if (elements.length!=0) {
            item.childNodes[0].data="Go to"
            item.childNodes[2].data="page"
          }else{
            setTimeout(setEn,100);
          }
        }
      }
    }
    setTimeout(setEn,100);
  },
  watch:{
    total(){
      let me=this
      function setEn(){
        let elements=document.getElementsByClassName('el-pagination__jump')||[]
        console.log(elements)
        for(let item of elements){
          item.style.color=me.jumperColor
          if (me.lan=='en') {
            if (elements.length!=0) {
              item.childNodes[0].data="Go to"
              item.childNodes[2].data="page"
            }else{
              setTimeout(setEn,100);
            }
          }
        }
      }
      setTimeout(setEn,100);
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, limit: val });
      // if (this.autoScroll) {
      //   scrollTo((this.forumTabsHeight || 0), 800)
      // }
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
      // if (this.autoScroll) {
      //   scrollTo((this.forumTabsHeight || 0), 800)
      // }
    },
  },
};
</script>

<style scoped>
.pagination-wrap {
  z-index: 4;
}
.pagination-wrap >>> .el-pagination {
  display: inline-block;
}

.pagination-wrap >>> .el-pagination__jump {
  color: #333333 !important;
}
.pagination-wrap >>> .btn-prev {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding: 5px 10px;

}
.pagination-wrap >>> .btn-next {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding:5px 10px;
}
.pagination-wrap >>> .btn-prev span,
.pagination-wrap >>> .btn-next span{
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #333333 !important;
}
.pagination-wrap >>> .el-pager li {
  background: #FFFFFF;
  color: #606266;
  border: 1px solid #CCCCCC;
}
.pagination-wrap >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #0071ff !important;
}
.tiaozhuan {
  display: inline-block;
  font-size: 13.5px;
  min-width: 35.5px;
  margin-left: 30px;
  margin-top: 2px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  /* border: 1px solid #DCDFE6; */
  background: #0071FF !important;
  color: #fff;
  padding: 0 8px;
  border-radius: 5px;
}

</style>
